module.exports = __webpack_public_path__ + "static/media/logo-white.3da2d82a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo-white.svg
// module id = 140
// module chunks = 0